import styles from './ResetPassPage.module.scss';
import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import { resetPassActions } from '../../../../stores/_actions';
import hidden from 'assets/images/icn-show.svg';
import show from 'assets/images/icn-hidden.svg';
import SideBanner from '../../components/side-banner/SideBanner';
import Label from '../../../../constants/Label';
import Validator from '../../../common/common-functions';
import { PopupModel } from '../../../components/popup/PopupModel';
import popup from '../../../components/popup/PopupModel.module.scss';
import popClose from 'assets/images/pop-close.svg';
import { Button } from 'semantic-ui-react';

function ResetPassPage(props) {
  const { location } = props;
  const jsonData = localStorage.getItem('customer');
  const customer = JSON.parse(jsonData);
  const customerCode = localStorage.getItem('CustomerCode');

  const [type, TextType] = useState('password');
  const InputType = () => (type == 'password' ? TextType('text') : TextType('password'));
  const [buttonActive, setButtonActive] = useState(false);
  // const location = useLocation();
  const history = useHistory();
  const menu = {
    beneficiary: false,
    amount: false,
    payment: false,
    confirm: true,
    transfer: false,
    print: false,
  };
  const menuValue = {
    ...location.state,
    menu,
    buttonActive,
  };

  const hidePopup = () => {
    openPopup(false);
    dispatch(resetPassActions.resetMsg());
    if (resetPassData && resetPassData.statusCode == '200') {
      history.push({ pathname: '/transfer', state: menuValue });
    }
  };

  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: JSON.parse(customerCode),
      IDNO: customer?.IDNO,
      Password: '',
      MobileNo: customer?.MobileNo,
      OTP: '',
      DeviceID: customer?.DeviceID,
      DeviceType: 'WEB',
    },
    Status: false,
    SessionID: null,
    IdType: null,
  };

  const verifyPayload = {
    Id: null,
    Message: null,
    CustomerCode: customerCode,
    Data: {
      Module: 'ForPin',
      DeviceID: customer?.DeviceID,
      DeviceType: 'WEB',
      IDNO: null,
      MobileNo: null,
      OTP: '',
    },
    Status: false,
    SessionID: null,
    IdType: null,
    Langcode: '0001',
  };

  const [pass, setPin] = useState({
    OTP: '',
    Password: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [modelPopup, openPopup] = useState(false);
  const logging = useSelector((state) => state);
  // const loggingIn = useSelector((state) => state.authentication.loggingIn);
  const dispatch = useDispatch();
  const resetPassData = useSelector((state) => state.resetPass?.data);
  const transferPage = localStorage.getItem('transfer');
  const url = ['/', transferPage == true ? '/transfer' : '/reset-password'];
  const handleChange = (e) => {
    let errorMsg;
    setPin((pass) => ({ ...pass, errorMsg: '', recall: '' }));
    const { name, value } = e.target;
    if (name === 'Password') {
      setPin((pass) => ({ ...pass, [name]: value }));
      setPin((pass) => ({ ...pass, errorPwdMsg: '' }));
    } else if ((name == 'one' || name == 'two' || name == 'three' || name == 'four' || name == 'five' || name == 'six').value != ' ') {
      const checkValidpass = Validator.digitsOnly(value);
      if (!checkValidpass) {
        errorMsg = 'Only digits allowed';
        setPin((pass) => ({ ...pass, [name]: '' }));
        setPin((pass) => ({ ...pass, errorMsg: errorMsg }));
        return;
      }
    }
    setPin((pass) => ({ ...pass, [name]: value }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setPin((pass) => ({ ...pass, errorMsg: '', recall: '1' }));
    let error = false;
    if (!pass.Password) {
      error = true;
      setPin((pass) => ({ ...pass, errorPwdMsg: 'Password is required' }));
    } else if (pass.Password.length < 8) {
      error = true;
      setPin((pass) => ({ ...pass, errorPwdMsg: 'Please enter 8 digit password' }));
    }
    if (pass.one && pass.two && pass.three && pass.four && pass.five && pass.six && pass.Password && !error) {
      payload.Data['OTP'] = `${pass.one}${pass.two}${pass.three}${pass.four}${pass.five}${pass.six}`;
      payload.Data['Password'] = pass.Password;
      payload.Data['CustomerCode'] = custDetails?.CustomerCode;
      payload.Data['IDNO'] = resetPwdDetails?.IDNO;
      payload.Data['MobileNo'] = custDetails?.MobileNo;
      verifyPayload.Data['OTP'] = `${pass.one}${pass.two}${pass.three}${pass.four}${pass.five}${pass.six}`;
      verifyPayload.Data['CustomerCode'] = custDetails?.CustomerCode;
      verifyPayload.Data['IDNO'] = resetPwdDetails?.IDNO;
      verifyPayload.Data['MobileNo'] = custDetails?.MobileNo;
      verifyPayload.Data['DeviceID'] = resetPwdDetails?.IDNO;
      dispatch(resetPassActions.validateOTP(verifyPayload, payload));
      // dispatch(resetPassActions.resetPass(payload));
    }
    openPopup(true);
  };
  const useMountEffect = (fun) => useEffect(fun, []);
  const UseFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
  };
  const [input1Val, setInput1Val] = useState('');
  const [input2Val, setInput2Val] = useState('');
  const [input3Val, setInput3Val] = useState('');
  const [input4Val, setInput4Val] = useState('');
  const [input5Val, setInput5Val] = useState('');
  const [input6Val, setInput6Val] = useState('');
  const [input1Ref, setInput1Focus] = UseFocus();
  const [input2Ref, setInput2Focus] = UseFocus();
  const [input3Ref, setInput3Focus] = UseFocus();
  const [input4Ref, setInput4Focus] = UseFocus();
  const [input5Ref, setInput5Focus] = UseFocus();
  const [input6Ref, setInput6Focus] = UseFocus();
  const [completeBtnRef, setCompleteFocus] = UseFocus();

  useMountEffect(setInput1Focus);
  let resetPwdDetails = {};
  let mobNo;
  let custDetails;
  useSelector((state) => {
    resetPwdDetails = state.forgotPass?.requestedData;
    mobNo = resetPwdDetails?.Mobileno;
    custDetails = state.getCustDetails?.data;
  }, []);

  return (
    <LoadingIndicator>
      <div className={styles.LoginPage}>
        <SideBanner />
        <div className={styles.LoginPage__loginform}>
          <h1>{Label.ResetPass.heading}</h1>
          <p>We have sent an OTP to +{`${mobNo?.substring(0, 3)}${mobNo?.substring(3)}`}. Validate your mobile number by entering the OTP below.</p>
          <form name="resetpass" onSubmit={handleSubmit} autoComplete="none">
            <div className={styles.LoginPage__formgroup}>
              <label>Enter OTP</label>
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="1"
                name="one"
                autoComplete="off"
                value={pass.one}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput1Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput2Focus();
                }}
                ref={input1Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="2"
                name="two"
                autoComplete="off"
                value={pass.two}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput2Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput3Focus();
                }}
                ref={input2Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="3"
                name="three"
                autoComplete="off"
                value={pass.three}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput3Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput4Focus();
                }}
                ref={input3Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="4"
                name="four"
                autoComplete="off"
                value={pass.four}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput4Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput5Focus();
                }}
                ref={input4Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="5"
                name="five"
                autoComplete="off"
                value={pass.five}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput5Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput6Focus();
                }}
                ref={input5Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="6"
                name="six"
                autoComplete="off"
                value={pass.six}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput6Val(val);
                  handleChange(e);
                  if (val.length === 1) setCompleteFocus();
                }}
                ref={input6Ref}
              />
              <div className={styles.formgroup__error}>{pass.errorMsg}</div>
              {submitted && pass.recall && !(pass.one && pass.two && pass.three && pass.four && pass.five && pass.six) && (
                <div className={styles.formgroup__error}>OTP is required</div>
              )}
            </div>
            <div className={styles.LoginPage__formgroup}>
              <label>Enter a new password</label>
              <input
                type={type}
                name="Password"
                maxLength="8"
                autoComplete="off"
                value={pass.Password}
                onChange={handleChange}
                className={styles.width50}
                style={{ textAlign: 'left', paddingLeft: '14px' }}
              />
              <img
                src={type == 'text' ? hidden : show}
                alt=""
                onClick={InputType}
                className={type == 'text' ? styles.formgroup__hidden : styles.formgroup__show}
              />
              <div className={styles.formgroup__error}>{pass.errorPwdMsg}</div>
              {/* {submitted && !pass.Password && <div className={styles.formgroup__error}>Enter new Password</div>} */}
            </div>
            <Link to={{ pathname: '/transfer', state: menuValue }}>
              <input
                type="button"
                value="Back"
                className={styles.LoginPage__link}
                style={{ width: '25%', marginRight: '10px' }}
                onClick={() => dispatch(resetPassActions.resetMsg())}
              />
            </Link>
            <input
              type="submit"
              value={Label.ResetPass.buttonLabel}
              className={styles.LoginPage__link}
              style={{ width: '25%', marginRight: '10px' }}
            />
            {submitted && resetPassData != undefined ? (
              <div className={styles.formgroup__error}>
                <h5>{resetPassData?.statusCode !== '200' && resetPassData.message}</h5>
              </div>
            ) : (
              ''
            )}
          </form>
          {modelPopup && resetPassData?.statusCode == '200' ? (
            <div className={popup.dialogue}>
              <div className={popup.dialogue__wrap}>
                <img className={popup.dialogue__close} src={popClose} onClick={hidePopup} />
                {resetPassData?.statusCode && (
                  <>
                    <p>{resetPassData.message}</p>
                    <br />
                  </>
                )}
                <div className={styles.pageLeft__buttonCenter} style={{ textAlign: 'center' }}>
                  <Button onClick={hidePopup} className="ui button">
                    {' '}
                    OK
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { ResetPassPage };
